// Auto-generated route mappings for Wayfinder
// Import root routes
import { home, gdpr, terms, references, login, logout, localLanding, contact } from './routes';

// Import nested routes
import * as reservations from './routes/reservations';
import * as equipment from './routes/equipment';
import * as accessories from './routes/accessories';
import * as contactRoutes from './routes/contact';
import * as profile from './routes/profile';
import * as password from './routes/password';
import * as verification from './routes/verification';
import * as admin from './routes/admin';
import * as adminReservations from './routes/admin/reservations';
import * as adminReservationsHours from './routes/admin/reservations/hours';
import * as adminEquipment from './routes/admin/equipment';
import * as adminMaintenance from './routes/admin/maintenance';
import * as adminCustomers from './routes/admin/customers';
import * as adminDraftReservations from './routes/admin/draft-reservations';
import * as adminPrices from './routes/admin/prices';
import * as adminTransportPrices from './routes/admin/transport-prices';
import * as adminTelemetry from './routes/admin/telemetry';
import * as adminTelemetrySync from './routes/admin/telemetry/sync';
import * as adminAuditLogs from './routes/admin/audit-logs';
import * as adminAuthenticationLogs from './routes/admin/authentication-logs';
import * as adminApi from './routes/admin/api';
// import * as api from './routes/api'; // Currently unused
import * as apiPricing from './routes/api/pricing';
import * as apiEquipment from './routes/api/equipment';
import * as apiAccessories from './routes/api/accessories';
import * as apiCustomerAddresses from './routes/api/customer-addresses';
import * as localLandingRoutes from './routes/local-landing';

// Import auth controller actions
import * as AuthenticatedSessionController from './actions/App/Http/Controllers/Auth/AuthenticatedSessionController';

// Route parameters type - flexible to match Wayfinder
type RouteParams = string | number | Record<string, unknown> | Array<unknown> | undefined;

// Map route names to Wayfinder route functions
// Note: Using Record<string, any> here because Wayfinder routes have complex, varied signatures
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const routeMap: Record<string, any> = {
    // Root routes
    'home': home,
    'gdpr': gdpr,
    'terms': terms,
    'references': references,
    'login': login,
    'login.store': AuthenticatedSessionController.store,
    'logout': logout,
    
    // Local landing routes
    'local-landing': localLanding,
    'local-landing.region': localLandingRoutes.region,
    'local-landing.district': localLandingRoutes.district,
    
    // Reservation routes
    'reservations.create': reservations.create,
    'reservations.continue': reservations.continueMethod,
    'reservations.success': reservations.success,
    'reservations.show': reservations.show,
    'reservations.cancel': reservations.cancel,
    'reservations.processStep': reservations.processStep,
    'reservations.clearSession': reservations.clearSession,
    
    // Equipment routes
    'equipment.index': equipment.index,
    'equipment.show': equipment.show,
    
    // Accessory routes
    'accessories.index': accessories.index,
    
    // Contact routes
    'contact': contact,
    'contact.submit': contactRoutes.store,
    
    // Profile routes
    'profile.edit': profile.edit,
    'profile.update': profile.update,
    'profile.destroy': profile.destroy,
    
    // Password routes
    'password.request': password.request,
    'password.email': password.email,
    'password.reset': password.reset,
    'password.store': password.store,
    'password.confirm': password.confirm,
    'password.update': password.update,
    
    // Verification routes
    'verification.notice': verification.notice,
    'verification.verify': verification.verify,
    'verification.send': verification.send,
    
    // Admin routes
    'admin.dashboard': admin.dashboard,
    'admin.statistics': admin.statistics,
    
    // Admin reservation routes
    'admin.reservations.index': adminReservations.index,
    'admin.reservations.create': adminReservations.create,
    'admin.reservations.store': adminReservations.store,
    'admin.reservations.show': adminReservations.show,
    'admin.reservations.edit': adminReservations.edit,
    'admin.reservations.update': adminReservations.update,
    'admin.reservations.destroy': adminReservations.destroy,
    'admin.reservations.cancel': adminReservations.cancel,
    'admin.reservations.confirm': adminReservations.confirm,
    'admin.reservations.emails': adminReservations.emails,
    'admin.reservations.send-email': adminReservations.sendEmail,
    'admin.reservations.hours.edit': adminReservationsHours.edit,
    'admin.reservations.hours.update': adminReservationsHours.update,
    
    // Admin equipment routes
    'admin.equipment.index': adminEquipment.index,
    'admin.equipment.show': adminEquipment.show,
    'admin.equipment.edit': adminEquipment.edit,
    'admin.equipment.update': adminEquipment.update,
    'admin.equipment.toggle-status': adminEquipment.toggleStatus,
    'admin.equipment.update-status': adminEquipment.updateStatus,

    // Admin maintenance routes
    'admin.maintenance.index': adminMaintenance.index,
    'admin.maintenance.update-status': adminMaintenance.updateStatus,
    'admin.maintenance.destroy': adminMaintenance.destroy,
    
    // Admin customer routes
    'admin.customers.index': adminCustomers.index,
    'admin.customers.create': adminCustomers.create,
    'admin.customers.store': adminCustomers.store,
    'admin.customers.show': adminCustomers.show,
    'admin.customers.edit': adminCustomers.edit,
    'admin.customers.update': adminCustomers.update,

    // Admin draft reservations routes
    'admin.draft-reservations.index': adminDraftReservations.index,
    'admin.draft-reservations.show': adminDraftReservations.show,
    'admin.draft-reservations.send-reminder': adminDraftReservations.sendReminder,
    'admin.draft-reservations.destroy': adminDraftReservations.destroy,
    'admin.draft-reservations.bulk-delete': adminDraftReservations.bulkDelete,

    // Admin price routes
    'admin.prices.index': adminPrices.index,
    'admin.prices.create': adminPrices.create,
    'admin.prices.store': adminPrices.store,
    'admin.prices.edit': adminPrices.edit,
    'admin.prices.update': adminPrices.update,
    
    // Admin transport price routes
    'admin.transport-prices.index': adminTransportPrices.index,
    
    // Admin telemetry routes
    'admin.telemetry.index': adminTelemetry.index,
    'admin.telemetry.show': adminTelemetry.show,
    'admin.telemetry.overview': adminTelemetry.overview,
    'admin.telemetry.sync.status': adminTelemetrySync.status,
    'admin.telemetry.sync.queue': adminTelemetrySync.queue,
    'admin.telemetry.sync.manual': adminTelemetrySync.manual,
    'admin.telemetry.assign': adminTelemetry.assign,
    'admin.telemetry.auto-assign': adminTelemetry.autoAssign,
    'admin.telemetry.unassign': adminTelemetry.unassign,
    'admin.telemetry.day': adminTelemetry.day,
    'admin.telemetry.sync': adminTelemetry.sync,

    // Admin audit log routes
    'admin.audit-logs.index': adminAuditLogs.index,

    // Admin authentication log routes
    'admin.authentication-logs.index': adminAuthenticationLogs.index,

    // Admin API routes
    'admin.api.dashboard-stats': adminApi.dashboardStats,
    'admin.api.calendar-events': adminApi.calendarEvents,
    'admin.api.calculate-distance': adminApi.calculateDistance,
    
    // API routes
    'api.pricing.calculate': apiPricing.calculate,
    'api.pricing.current': apiPricing.current,
    'api.equipment.availability': apiEquipment.availability,
    'api.accessories.for-equipment': apiAccessories.forEquipment,
    'api.accessories.by-type': apiAccessories.byType,
    'api.customer-addresses.by-contact': apiCustomerAddresses.byContact,
    'api.customer-addresses.save': apiCustomerAddresses.save,
    'api.customer-addresses.search': apiCustomerAddresses.byContact, // alias for backward compatibility
};

// Route helper with current() method for checking active routes
interface RouteFunction {
    (name: string, params?: RouteParams, absolute?: boolean): string;
    current: (pattern: string) => boolean;
}

// Check if current URL matches a route pattern
function checkCurrentRoute(pattern: string): boolean {
    if (typeof window === 'undefined') return false;

    const currentPath = window.location.pathname;

    // Check exact match first
    if (pattern.includes('*')) {
        // For wildcard patterns, check if current path starts with the base
        const basePattern = pattern.replace(/\.\*$/, '').replace(/\./g, '/');
        return currentPath.startsWith('/' + basePattern);
    } else {
        // For exact patterns, check exact match
        const exactPath = '/' + pattern.replace(/\./g, '/');
        return currentPath === exactPath;
    }
}

// Global route function for Wayfinder routes
const routeFunction: RouteFunction = function route(name: string, params?: RouteParams, absolute?: boolean): string {
    const routeFunc = routeMap[name];
    
    if (!routeFunc) {
        console.error(`Route "${name}" not found`);
        return '#';
    }
    
    try {
        // If it has a url method, use it
        if (typeof routeFunc.url === 'function') {
            const url = routeFunc.url(params);
            
            if (absolute && typeof window !== 'undefined') {
                return window.location.origin + url;
            }
            
            return url;
        }
        
        // If it's a route object with definition
        if (routeFunc.definition && routeFunc.definition.url) {
            const url = routeFunc.definition.url;
            
            if (absolute && typeof window !== 'undefined') {
                return window.location.origin + url;
            }
            
            return url;
        }
        
        throw new Error(`Route "${name}" is not properly configured`);
    } catch (error) {
        console.error(`Error generating route "${name}":`, error);
        return '#';
    }
}

// Add current method to route function
routeFunction.current = checkCurrentRoute;

// Export the enhanced route function
export const route = routeFunction;

// Augment Window interface
declare global {
    interface Window {
        route: RouteFunction;
    }
}

// Make route function available globally
if (typeof window !== 'undefined') {
    window.route = route;
}